<template>
    <section>
        <div class="container-fluid">
            <div class="row fl-j-c">
                <div class="col-12 col-lg-9 col-xl-8">
                    <div class="d-block mt-5">
                        <ProgressSection/>
                    </div>
                    <div class="card-type-1 p-4 p-lg-5">
                        <section class="login-section">
                            <div>
                                <p class="heading-type-1 text-primary">Authentication</p>
                                <p class="">We've sent an OTP to the mobile number +91 9876543210.
                                    <span class="c-font-12 text-grey"><a href="#">Change</a></span></p>
                            </div>

                            <div class="login-section-form">
                                <div class="form-group input-type-1">
                                    <label for="usr">Enter OTP</label>
                                    <input type="text" class="form-control" placeholder="Enter the OTP" id="usr"
                                           name="username">
                                </div>

                                <div class="row fl-j-c">

                                    <div class="col-lg-4">
                                        <router-link to="/deliver-option/" class="lego-btn xeo-btn-type-1 btn-block">Continue</router-link>
                                    </div>

                                </div>

                            </div>

                        </section>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ProgressSection from '../components/Progress-section';

export default {
    components: { ProgressSection },
    metaInfo: {
        title: 'Authentication'
    },
    name: 'Authentication'
};
</script>

<style scoped>

</style>
